import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { toast } from 'sonner'
import './app.css'
import { AppToaster } from './components/app-toaster'
import { TooltipProvider } from './components/ui/tooltip'
import { errorMessage, isApiError } from './lib/api'
import { router } from './router'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 4xx answers do not get better by asking again
      retry: (count, err) => count < 2 && !(isApiError(err) && err.status >= 400 && err.status < 500),
      refetchOnWindowFocus: true,
    },
  },
  mutationCache: new MutationCache({
    // a mutation that handles its own errors sets meta.silent
    onError: (err, _vars, _ctx, mutation) => {
      if (!mutation.meta?.silent) toast.error(errorMessage(err))
    },
  }),
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <RouterProvider router={router} />
        <AppToaster />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
)
